/**
 * @file routesConfig.ts
 * @description
 *   This file defines the main route configuration for the Negotiation Buddy Web Application.
 *   Each route object specifies the URL path, the React component to render for that path,
 *   and whether the route is protected (requires authentication/authorization).
 *
 *   The routes array is used by the application's router to determine which component to display
 *   based on the current URL. All components are imported at the top of the file.
 *
 * @example
 *   import routes from './config/routesConfig';
 *   // Used in <Routes> mapping in App.tsx
 *
 * @exports
 *   routes - An array of route configuration objects for use with React Router.
 */

import React from 'react';
import Dashboard from '../pages/Dashboard/Dashboard';
import NegotiationStepperForm from '../pages/Negotiation Process/NegotiationStepperForm';
import Profile from '../pages/Profile/Profile';
import DetailedOverview from '../pages/Dashboard/Overview/Detailed Negotition Overview/detailedOverview';
import DocumentOutcome from '../pages/Dashboard/DocumentOutcome';
import ReviewNegotiation from '../pages/Dashboard/ReviewNegotiation/ReviewNegotiation';
import CloseNegotiationPage from '../pages/Dashboard/Overview/Close Negotiation/closeNegotiationPage';

const routes = [
    {
        path: '/',
        element: React.createElement(Dashboard),
        protected: true,
    },
    {
        path: '/negotiationForm',
        element: React.createElement(NegotiationStepperForm),
        protected: true,
    },
    {
        path: '/profile',
        element: React.createElement(Profile),
        protected: true,
    },
    {
        path: '/detailedOverview',
        element: React.createElement(DetailedOverview),
        protected: true,
    },
    {
        path: '/DocumentOutcome',
        element: React.createElement(DocumentOutcome),
        protected: true,

    },
    {
        path: '/ReviewNegotiation',
        element: React.createElement(ReviewNegotiation),
        protected: true,

    },
    {
        path: '/closeNegotiation',
        element: React.createElement(CloseNegotiationPage),
        protected: true,
    }
];

export default routes;